import React from 'react';
import { useState, useContext } from 'react';
import {useLocation, useNavigate} from "react-router-dom";
import './login.css';
import { setToken, setName, fetchToken, fetchRole, setRole } from './Token';
import { api } from '../api';
import AuthContext from './AuthProvider';
import {LinearProgress, Box} from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';


export const Login = () => {
    const navigate = useNavigate();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('Welcome To The Cooperative')
    const [loading, setLoading] = useState("")
    const { setPermissions } = useContext(AuthContext);
        // const handleInputChange = (event) => {
        // const value = event.target.value;
        // setFormData({
        //   ...formData,
        //   [event.target.name]: value,
        // });
        // };
 
        const handleFormSubmit = async (event) => {
            event.preventDefault();
            setLoading("load")
          
            const formData = new FormData();
            formData.append('username', username);
            formData.append('password', password);
          
            try {
              const response = await api.post('/auth/login', formData);
              if (response?.data?.token){
                setToken(response.data.token)
                setRole(response.data.role)
                setPermissions(response.data.role);
                localStorage.setItem('authData', JSON.stringify(response.data.role))
                localStorage.setItem('society_data', JSON.stringify(response.data.data))
                navigate(
                  response.data?.role?.role_name === "Credit Officer"?
                    "/credit-officer": 
                  response.data?.role?.role_name === "Operations Manager"?
                    "/operations-manager" :
                  response.data?.role?.role_name === "Society Manager"?
                    "/society-manager" :
                  response.data?.role?.role_name === "Cashier"?
                    "/cashier" :
                    "/dashboard"
                );
                setName(username)
              }else if(response.data.error){
                setError("Invalid Credentials")
                setLoading("")
              }
                
            } catch (error) {
              if (!error?.response) {
                setError('No Server Response');
		            console.log(error);
                setLoading("")
              }
          };
        };

  return (
        <div className="container">
	<div className="screen">
		<div className="screen__content">
			<form className="login" onSubmit={handleFormSubmit}>
                    <p className="loginn">Log in</p>
            <p className="error">{error}</p>
				<div className="login__field">
					<i className="login__icon fas fa-user"></i>
					<input type="text" className="login__input" required placeholder="User name" value={username} name='username' id="username" onChange={(e) => setUsername(e.target.value)}/>
				</div>
				<div className="login__field">
					<i className="login__icon fas fa-lock"></i>
					<input type="password" className="login__input" required placeholder="Password" value={password} name="password" id="password" onChange={(e) => setPassword(e.target.value)}/>
				</div>
				<button className="button login__submit" type='submit'>
          
          { loading === "load" ?  <Box sx={{ width: '100%' }}>
                                    <CircularProgress />
                                  </Box> :
          <><span className="button__text">Log In</span>
					<i className="button__icon fas fa-chevron-right"></i> </>}

					
				</button>				
			</form>
			
		</div>
		<div className="screen__background">
			<span className="screen__background__shape screen__background__shape4"></span>
			<span className="screen__background__shape screen__background__shape3"></span>		
			<span className="screen__background__shape screen__background__shape2"></span>
			<span className="screen__background__shape screen__background__shape1"></span>
		</div>		
	</div>
</div>
  );
};
